import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { switchMap } from 'rxjs/operators';
import { Role } from 'src/app/entities/role';
import { RoleName } from 'src/app/entities/util';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/sharedService';
import { Errors } from 'src/app/util/errors';
import { environment } from 'src/environments/environment';
import { MenuCategories } from '../top-menu/menuItems';
import { CompanyDexieService } from 'src/app/services/companyDexie-services/companyDexie.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tas-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public username: string;
  public password: string;
  public error: string;
  lang = { fr: true, en: false }
  roleNames = RoleName
  notifParam: any;
  initialRoute = 'dashboard'
  propertyTaxRoute = 'property-tax'
  taxPayersRoute = 'tax_payers'
  hidePassword = true;
  constructor(private sharedService: SharedService, private translate: TranslateService,
    private companyDexieService: CompanyDexieService, private authService: AuthService,
    private jwtHelper: JwtHelperService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.setServerPath()
    localStorage.removeItem('municipalityBbox')
    localStorage.removeItem('municipalityName')
    localStorage.removeItem('municipality')
  }

  setServerPath() {
    return new Promise(resolve => {
      this.sharedService.getServerStatus(environment.apihost[0]).subscribe((resp) => {
        this.initializeSettings(environment.apihost[0]).then(resolve)
      }, err => {
        this.initializeSettings(environment.apihost[1]).then(resolve)
      })
    })
  }

  initializeSettings(path) {
    return new Promise(resolve => {
      // setServerPath() has just probed which host is actually reachable, so
      // that result is authoritative. This used to write only when the key was
      // absent, which meant a serverPath saved once could never be corrected —
      // if it pointed at a host that was later retired, every login attempt
      // went there forever and the only fix was clearing storage by hand.
      localStorage.setItem("serverPath", path);
      const token = this.jwtHelper.tokenGetter()
      if (token && token !== 'undefined') {
        const decodedToken = this.jwtHelper.decodeToken(token);
        var routePath = MenuCategories.get(decodedToken.role)[0][0]
        this.router.navigate([routePath]);
      }
      this.route.queryParamMap.subscribe(q => {
        this.notifParam = q['params'].notifications
      });
      resolve({});
    })
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  login(username, password) {
    if (!username.value || !password.value) {
      this.error = Errors.PROVIDE_USERNAME_PASSWORD;
      return
    }
    this.authService.login(username.value, password.value).pipe(
      switchMap(result => {
        this.authService.setLoginStatus(result);
        return this.authService.getUserRole$();
      })
    ).subscribe(async role => {
      await this.companyDexieService.addSynchinfo(true)
      if (role === this.roleNames.get(Role.ADMIN)) {
        this.router.navigate([this.initialRoute]);
      } else if (['AGENT_RECENSEUR', 'PROPERTIES_EDITOR', 'PROPERTIES_LECTEUR'].includes(role)) {
        this.router.navigate([this.propertyTaxRoute]);
      } else if (['SECRETARY_ASSISTANT'].includes(role)) {
        this.router.navigate([this.taxPayersRoute]);
      }else {
        const queryParams = this.notifParam ? { notifications: true } : undefined;
        this.router.navigate([this.initialRoute], { queryParams });
      }
    },
      err => {
        if (err.status === 0) {
          this.error = Errors.CONNECTION_FAILED;
        }
        if (err.status === 401) {
          if (err.error && err.error.message === "PASSWORD_EXPIRED") {
            const queryParams = { vercode: err.error.vercode, renew: true }
            this.router.navigate(['password_restore'], { queryParams })
            return;
          }

          if (err.error && err.error.message === "ALREADY_LOGGED_IN") {
            this.error = Errors.ALREADY_LOGGED_IN;
            return;
          }

          this.error = Errors.UNAUTHORIZED;
        }
      });
  }

  changeLang(ln) {
    this.lang[ln] = true
    for (let l in this.lang) {
      if (ln !== l) {
        this.lang[l] = false
      }
    }
    this.sharedService.setLan(ln);
    this.translate.use(ln);
  }

}
